/**
 * productDisplay.js — presentation rules for subscription/ICOD products.
 *
 * Products carry `duration` / `rental_length` fields that stay populated even
 * when the product never expires (the admin leaves the stale default behind).
 * Rendering them unguarded advertises a one-time perpetual purchase as a
 * monthly rental — e.g. the "Season Pass" ICOD product on The Ark - Season 3
 * ships duration {number: 1, unit: 'month'} alongside never_expires: true.
 */

/** Access never expires — the duration fields on the record are meaningless. */
export const isPerpetualProduct = product =>
  product?.never_expires === true || product?.rental_length_selection === 'neverexpires';

/**
 * Whether to render the "/ N unit" suffix next to a product price.
 * Recurring subscriptions and timed rentals keep it; perpetual buys don't.
 */
export const shouldShowProductDuration = product =>
  Boolean(product?.duration?.unit) && !isPerpetualProduct(product);
